import { useMemo } from "react";
import { isEmpty } from "remeda";

import { Typography } from "@/components/ui/typography";

const DynamicTable = ({ data }: { data: any[] }) => {
  const transposedData = useMemo(() => {
    if (isEmpty(data)) return [];

    const keys = Object.keys(data[0]);
    return keys.map((key) => ({
      key,
      values: data.map((row) => row[key]),
    }));
  }, [data]);

  if (isEmpty(data)) {
    return <Typography>No Data</Typography>;
  }

  return (
    <div className="overflow-x-auto max-w-[75vw] border border-gray-300 shadow-md rounded-lg">
      <table className="border-collapse min-w-full">
        <tbody>
          {transposedData.map(({ key, values }) => (
            <tr key={key} className="hover:bg-gray-50">
              {/* Sticky first column */}
              <td className="border border-gray-300 px-4 py-2 text-black font-semibold whitespace-nowrap bg-white sticky left-0 z-10">
                {key}
              </td>
              {values.map((value, index) => (
                <td key={index} className="border border-gray-300 px-4 py-5 text-black">
                  {value}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DynamicTable;
